//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ShippingPerformanceCommand: any = {
    UpdateShippingPerformance: Backofficebff + '/v1/cargo/update-cost-performance-bar',
};
